document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.taelux-announcement__item');
  const toggle = document.getElementById('taeluxAnnouncementToggle');

  if (!items.length) return;

  const pauseIcon = toggle?.querySelector('.taelux-pause-icon');
  const playIcon = toggle?.querySelector('.taelux-play-icon');

  let index = 0;
  let paused = false;

  items.forEach(item => item.classList.remove('active'));
  items[0].classList.add('active');

  setInterval(function () {
    if (paused) return;

    items[index].classList.remove('active');
    index = (index + 1) % items.length;
    items[index].classList.add('active');
  }, 3500);

  if (toggle) {
    toggle.addEventListener('click', function () {
      paused = !paused;

      if (pauseIcon && playIcon) {
        pauseIcon.hidden = paused;
        playIcon.hidden = !paused;
      }
    });
  }
});